import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from './../../app/store';

interface Avatar{
  name: string,
  url: string,
}

interface ItemToDelete {
  sectionItemId: string;
  // sectionId: string;
}

interface UpdateLinksSectionItem {
  id: string,
  data: Partial<MediakitSectionItem>
}

export interface MediakitSectionItem{
  id: string,
  mediakitSectionId: string,
  platform: string,
  contentType: string,
  description: string,
  currency?: string,
  price?: any,
  alfanShare?: any,
  url: string,
  orderNumber: number,
  isVisible: boolean,
  isMonetize: boolean,
  isActive?: boolean,
  duration?: string | null,
  title?: string | null,
  channelProfileIcon?: string | null,
  videoThumbnail?: string | null,
  customUploadedImage?: any | null,
  metadata?: any,
}

export interface MediakitSection{
  id: string,
  isVisible: boolean,
  mediakitSectionLinks: MediakitSectionItem[],
  title?: string,
  subtitle?: string,
  type: string,
  updateTitle?: boolean
}

interface UpdateMediakitSectionTitle{
  id: string;
  title: string;
}

export interface MediakitUserState {
    id: string | null,
    fullname: string | null,
    nickname: string | null,
    country: string | null,
    bio: string | null,
    avatarUrl: string | null,
    displayFollower: boolean | null,
    mediakitSection: MediakitSection[],
}

const initialState: MediakitUserState = {
  id: 'new-mediakit',
  fullname: null,
  nickname: null,
  country: '',
  bio: '',
  avatarUrl: null,
  displayFollower: true,
  mediakitSection: [{id: 'rates', type: 'rates', mediakitSectionLinks: [], isVisible: true}, {id: 'social', type: 'social', mediakitSectionLinks: [], isVisible: true}, {id: 'video', type: 'video', mediakitSectionLinks: [], isVisible: true}],
};


export const mediakitUser = createSlice({
  name: 'mediakitUser',
  initialState,
  reducers: {
    setMediakitUser: (state, action: PayloadAction<MediakitUserState>) => {
      const mediakitUser = action.payload;
      state.avatarUrl = mediakitUser.avatarUrl,
      state.fullname = mediakitUser.fullname,
      state.bio = mediakitUser.bio,
      state.country = mediakitUser.country;
      state.displayFollower = mediakitUser.displayFollower;
      state.mediakitSection = mediakitUser.mediakitSection;
      state.nickname = mediakitUser.nickname;
    },
    addSectionItem: (state, action: PayloadAction<MediakitSectionItem>) => {
      const targetSectionIndex = state.mediakitSection.findIndex((e) => e.id === action.payload.mediakitSectionId);
      state.mediakitSection[targetSectionIndex].mediakitSectionLinks = [...state.mediakitSection[targetSectionIndex].mediakitSectionLinks, action.payload];
    },
    updateSectionItems: (state, action: PayloadAction<any>) => {
      const targetSectionIndex = state.mediakitSection.findIndex((e) => e.id === action.payload.obj.mediakitSectionId);
      // state.mediakitSection[targetSectionIndex].mediakitSectionLinks = [...state.mediakitSection[targetSectionIndex].mediakitSectionLinks, action.payload];
      state.mediakitSection[targetSectionIndex].mediakitSectionLinks = action.payload.data;
    },
    updateSectionItem: (state, action: PayloadAction<UpdateLinksSectionItem>) => {
      state.mediakitSection = state.mediakitSection.map((section) => {
        const items = section.mediakitSectionLinks;
        const itemIndex = items.findIndex((e) => e.id === action.payload.id);
        if (itemIndex !== -1) {
          section.mediakitSectionLinks[itemIndex] = {...section.mediakitSectionLinks[itemIndex], ...action.payload.data};
        }
        return section;
      });
    },
    deleteMediakitSectionItem: (state, action: PayloadAction<ItemToDelete>) => {
      state.mediakitSection = state.mediakitSection.map((section: MediakitSection) => {
        return {...section, mediakitSectionLinks: section.mediakitSectionLinks.filter((item: MediakitSectionItem) => item.id !== action.payload.sectionItemId)};
      });
    },
    sortMediakitSectionItems: (state) => {
      state.mediakitSection = state.mediakitSection.map((section: MediakitSection) => {
        return {...section, mediakitSectionLinks: section.mediakitSectionLinks.slice().sort((a: any, b: any) => {
          if (a.orderNumber > b.orderNumber) return 1;
          else return -1;
        })};
      });
    },
    resetMediakitUser: (state, action) => {
      const user = action.payload.me.mediakitUser;
      const me = action.payload.me;
      const userExist = user?.id ? true : false;
      state.id = user.id;
      state.avatarUrl = user.avatarUrl;
      state.fullname = userExist ? user.fullname : (me?.linksUser?.fullname || '');
      state.bio = userExist ? user.bio : (me?.linksUser?.bio || '');
      state.country = userExist ? user.country : (me?.linksUser?.location || '');
      state.displayFollower = user.displayFollower;
      state.nickname = me?.linksUser?.nickname,
      state.mediakitSection = action.payload.me.mediakitUser.mediakitSection.map((section: MediakitSection) => {
        return {...section, mediakitSectionLinks: section.mediakitSectionLinks.map((e: MediakitSectionItem) => {
          return e;
        }).sort((a: any, b: any) => {
          if (a.orderNumber > b.orderNumber) return 1;
          else return -1;
        })};
      });
    },
    updateSectionTitle: (state, action: PayloadAction<UpdateMediakitSectionTitle>) => {
      const targetSectionIndex = state.mediakitSection.findIndex((e) => e.id === action.payload.id);
      state.mediakitSection[targetSectionIndex] = {...state.mediakitSection[targetSectionIndex], title: action.payload.title, updateTitle: true};
    },
  },
  extraReducers: {
    'user/setMe': (state, {payload}) => {
      if (payload.me?.mediakitUser) {
        const mediakitUser = payload.me.mediakitUser?.id ? payload.me.mediakitUser : initialState;
        const user = payload.me;
        const userExist = mediakitUser?.id === 'new-mediakit' ? false : true;
        state.id = mediakitUser?.id;
        state.avatarUrl = mediakitUser?.avatarUrl,
        state.fullname = userExist ? mediakitUser?.fullname : (user?.linksUser?.fullname || ''),
        state.bio = userExist ? mediakitUser?.bio : (user?.linksUser?.bio || ''),
        state.country = userExist ? mediakitUser?.country : (user?.linksUser?.location || '');
        state.displayFollower = mediakitUser?.displayFollower;
        state.nickname = user?.linksUser?.nickname,
        state.mediakitSection = mediakitUser?.mediakitSection?.map((section: MediakitSection) => {
          return {...section, mediakitSectionLinks: section.mediakitSectionLinks.map((e: MediakitSectionItem) => {
            return e;
          }).sort((a: any, b: any) => {
            if (a.orderNumber > b.orderNumber) return 1;
            else return -1;
          })};
        }) || [];
      }
    },
  },
});

// this thunk is used because it has access to the global store and thus the logged in user
export const resetMediakitUserThunk = (): any => {
  return (dispatch: any, getState: any) => {
    const {user} = getState();
    dispatch(resetMediakitUser(user));
  };
};

export const {
  setMediakitUser,
  deleteMediakitSectionItem,
  addSectionItem,
  updateSectionItem,
  sortMediakitSectionItems,
  resetMediakitUser,
  updateSectionTitle,
  updateSectionItems,
} = mediakitUser.actions;

export const selectMediakitUser = (state: RootState) => state.mediakitUser as MediakitUserState;

export default mediakitUser.reducer;
